

























































































import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';

import { useMutation, useQuery } from '@vue/apollo-composable';

import ChartWithLastYearCompare from '@/components/Report/ChartWithLastYearCompare.vue';
import ChartWithLastYearPercentageCompare from '@/components/Report/ChartWithLastYearPercentageCompare.vue';
import DeliveryPerPriceByHub from '@/components/Report/03-Profit/3.2-DeliveryPerPrice/DeliveryPerPriceByHub.vue';
import DeliveryPerPriceByArea from '@/components/Report/03-Profit/3.2-DeliveryPerPrice/DeliveryPerPriceByArea.vue';
import ChartWithFtlCompare from '@/components/Report/03-Profit/3.2-DeliveryPerPrice/ChartWithFtlCompare.vue';
import ChartWithLtlCompare from '@/components/Report/03-Profit/3.2-DeliveryPerPrice/ChartWithLtlCompare.vue';
import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';
import TreemapAreaExpense from '@/components/Report/02-Expense/TreemapAreaExpense.vue';

import priceIndex from '@/gql/managementReport/03-Profit/3.2-DeliveryPerPrice/priceIndex.gql';
import monthPriceIndex from '@/gql/managementReport/03-Profit/3.2-DeliveryPerPrice/monthPriceIndex.gql';
import monthsNetProfit from '@/gql/managementReport/03-Profit/monthsNetProfit.gql';
import netProfitRange from '@/gql/managementReport/03-Profit/netProfitRange.gql';
import hubsNetProfit from '@/gql/managementReport/03-Profit/hubsNetProfit.gql';
import areasNetProfit from '@/gql/managementReport/03-Profit/areasNetProfit.gql';

const DeliveryPerPriceRatio = defineComponent({
  components: {
    SmallChartPanel,
    ChartWithLastYearCompare,
    ChartWithLastYearPercentageCompare,
    ChartWithFtlCompare,
    ChartWithLtlCompare,
    DeliveryPerPriceByHub,
    DeliveryPerPriceByArea,
    TreemapAreaExpense,

  },
  setup() {
    const { result: getTopInfo } = useQuery(priceIndex, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeY1: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.priceIndex || {});
    const getPanelInfoMtd = computed(() => getTopInfo.value?.priceIndexMTD || {});

    return {
      priceIndex,
      monthPriceIndex,
      monthsNetProfit,
      netProfitRange,
      hubsNetProfit,
      areasNetProfit,

      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default DeliveryPerPriceRatio;
